module.exports = __webpack_public_path__ + "img/Status_Pending.33ae6ba8.svg";